import { createFileRoute } from "@tanstack/react-router";
import Features from "@/pages/Features";
import { pageHead } from "@/lib/seo";
import { featuresBreadcrumb, featuresFaqSchema } from "@/utils/schema";

export const Route = createFileRoute("/features")({
  head: () => ({
    ...pageHead("/features", "en"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresBreadcrumb("en")),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresFaqSchema("en")),
      },
    ],
  }),
  component: Features,
});
